import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles(() => ({
  popover: {},
  content: {
    padding: '8px 16px',
  },
  container: {
    '& h4': {
      fontSize: 14,
      color: '#37474f',
      fontWeight: 500,
    },
    '& a': {
      color: 'black',
    },
    '& div:not(:last-child)': {
      '& $content': {
        borderBottom: 'solid 1px #e0e0e0',
      },
    },
  },
  title: {
    display: 'flex',
    fontSize: 16,
    padding: '8px 16px',
    textTransform: 'uppercase',
    fontWeight: 600,
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#192542',
  },
  footer: {
    padding: '8px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#928989',
    fontSize: 12,
  },
  type: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  badgeIcon: {
    color: '#ffffff',
  },
  badgePosition: {
    right: 16,
  },
  empty: {
    padding: 16,
    textAlign: 'center',
  },
  button: {
    textTransform: 'inherit',
  },
  alert: {
    fontSize: 12,
    maxWidth: 300,
    marginTop: 8,
  },
  iconButton: {
    color: '#fff',
  },
  badge: {
    top: 5,
    rigth: -2,
  },
}));
